import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=3abf95af&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"
import style0 from "./setting.vue?vue&type=style&index=0&id=3abf95af&prod&scoped=true&lang=scss"
import style1 from "./setting.vue?vue&type=style&index=1&id=3abf95af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf95af",
  null
  
)

export default component.exports